(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
(() => {
  const flip = document.getElementById('ab-flip');
  if (!flip || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  flip.classList.add('armed');
  const line = flip.nextElementSibling;
  const io = new IntersectionObserver(es => {
    es.forEach(e => {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      requestAnimationFrame(() => {
        e.target.classList.add('in');
        if (e.target.classList.contains('ab-wit') && line) line.classList.add('in');
      });
    });
  }, { threshold: 0.6 });
  flip.querySelectorAll('.ab-rec, .ab-wit').forEach(el => io.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-companion"] && !Shopify.designMode) return;
  try {
    
(() => {
  const stage = document.getElementById('tour-stage');
  const device = document.getElementById('tour-device');
  const shots = [...document.querySelectorAll('#tour-screens img, #tour-screens video')];
  const hot = document.getElementById('tour-hotspot');
  const cap = document.getElementById('tour-caption');
  const dotsHost = document.getElementById('tour-dots');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* no hover, no tilt: on touch screens the idle sway reads as throbbing */
  const coarse = matchMedia('(hover: none), (pointer: coarse)').matches;
  if (!shots.length) return;
  let cur = 0;

  const dots = shots.map((_, i) => {
    const d = document.createElement('button');
    d.setAttribute('aria-label', 'Step ' + (i + 1));
    d.addEventListener('click', () => goTo(i));
    dotsHost.appendChild(d); return d;
  });

  /* *word* in a caption is highlighted; built from text nodes, never HTML */
  function setCaption(t) {
    cap.textContent = '';
    t.split(/\*([^*]+)\*/).forEach((part, k) => {
      if (!part) return;
      if (k % 2) { const em = document.createElement('em'); em.textContent = part; cap.appendChild(em); }
      else cap.appendChild(document.createTextNode(part));
    });
  }

  function goTo(i, dir) {
    const n = (i + shots.length) % shots.length;
    if (n === cur && cap.textContent) return;
    shots.forEach(s => s.classList.remove('on', 'off-l'));
    const s = shots[n];
    s.classList.add('on');
    cur = n;
    setCaption(s.dataset.caption);
    shots.forEach(sh => { if (sh.tagName === 'VIDEO') {
      if (sh === s) { sh.currentTime = 0; sh.play().catch(() => {}); } else sh.pause();
    }});
    dots.forEach((d, k) => d.classList.toggle('on', k === cur));
    hot.setAttribute('aria-label', cur === shots.length - 1 ? 'Start over' : 'Next');
  }
  hot.addEventListener('click', () => goTo(cur + 1, 1));
  document.getElementById('tour-next').addEventListener('click', () => goTo(cur + 1, 1));
  document.getElementById('tour-prev').addEventListener('click', () => goTo(cur - 1, -1));

  /* swipe moves either way; a still tap on the screen advances */
  let sx = null;
  stage.addEventListener('pointerdown', e => { sx = e.clientX; }, { passive: true });
  stage.addEventListener('pointerup', e => {
    if (sx === null) return;
    const dx = e.clientX - sx; sx = null;
    if (dx < -40) goTo(cur + 1, 1);
    else if (dx > 40) goTo(cur - 1, -1);
    else if (Math.abs(dx) < 10 && e.target.closest('.tour-frame') &&
             !e.target.closest('#tour-hotspot')) goTo(cur + 1, 1);
  }, { passive: true });

  /* the suspended object answers the hand; drifts when left alone */
  let idleT = 0;
  function aim(nx, ny) {
    device.style.transform = `rotateX(${(-ny * 9).toFixed(2)}deg) rotateY(${(nx * 12).toFixed(2)}deg) translateZ(18px)`;
  }
  if (!coarse) addEventListener('pointermove', (e) => {
    const r = stage.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    idleT = Date.now();
    const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    aim(clampN((e.clientX - cx) / r.width, -0.6, 0.6), clampN((e.clientY - cy) / r.height, -0.6, 0.6));
  }, { passive: true });
  function clampN(x, a, b) { return Math.min(b, Math.max(a, x)); }
  function drift() {
    if (!reduced && Date.now() - idleT > 2600) {
      const t = Date.now() / 1000;
      aim(Math.sin(t * 0.23) * 0.55, Math.cos(t * 0.19) * 0.45);
    }
    requestAnimationFrame(drift);
  }
  if (!reduced && !coarse) requestAnimationFrame(drift);

  goTo(0, 0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["between-phones"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tabs = [...document.querySelectorAll('#soc-tabs button')];
  const L = [...document.querySelectorAll('#soc-left img')];
  const R = [...document.querySelectorAll('#soc-right img')];
  const caps = [...document.querySelectorAll('[data-cap]')];
  const cap = document.getElementById('soc-caption');
  const dot = document.getElementById('soc-dot');
  const path = document.getElementById('soc-path');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let cur = 0;
  function show(i) {
    cur = i;
    tabs.forEach((t, k) => t.classList.toggle('on', k === i));
    L.forEach((img, k) => img.classList.toggle('on', k === i));
    R.forEach((img, k) => img.classList.toggle('on', k === i));
    cap.textContent = caps[i] ? caps[i].textContent : '';
    t0 = performance.now();
  }
  tabs.forEach(t => t.addEventListener('click', () => show(Number(t.dataset.i))));
  /* a moment travels: the dot rides the arc, left phone to right phone */
  const len = path.getTotalLength();
  let t0 = performance.now();
  function fly(ts) {
    const period = 3600;
    const p = ((ts - t0) % period) / period;
    const eased = p < 0.82 ? (1 - Math.cos(Math.PI * (p / 0.82))) / 2 : 1;
    const pt = path.getPointAtLength(eased * len);
    dot.setAttribute('x', pt.x - 3); dot.setAttribute('y', pt.y - 3);
    dot.setAttribute('opacity', p > 0.94 ? 0 : 1);
    requestAnimationFrame(fly);
  }
  if (!reduced) requestAnimationFrame(fly);
  else { const pt = path.getPointAtLength(len * 0.5); dot.setAttribute('x', pt.x - 3); dot.setAttribute('y', pt.y - 3); }
  show(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["demo-proof"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cv = document.getElementById('demo-canvas');
  const wrap = cv.parentElement;
  const press = document.getElementById('demo-press');
  const after = document.getElementById('demo-after');
  const came = document.getElementById('demo-came');
  const tie = document.getElementById('demo-tie');
  const lead = document.getElementById('demo-lead');
  const hold = document.getElementById('demo-hold');
  const back = document.getElementById('demo-back');
  const hint = document.getElementById('demo-hint');
  const ctx = cv.getContext('2d');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* the present is visible for a blink; the buffer holds ten seconds */
  const BUF_MS = 10000, FADE = 340;
  let pts = [], replay = null, hasDrawn = false, dpr = 1;
  let ghostG = 0, ghostPts = [];

  function size() {
    dpr = Math.min(devicePixelRatio || 1, 2);
    cv.width = wrap.clientWidth * dpr; cv.height = wrap.clientHeight * dpr;
  }
  size(); addEventListener('resize', size);

  function add(x, y) {
    const r = wrap.getBoundingClientRect();
    const p = { x: (x - r.left) * dpr, y: (y - r.top) * dpr, t: performance.now() };
    pts.push(p);
    if (!hasDrawn) { hasDrawn = true; hint.style.opacity = '0'; }
    if (reduced) {
      /* no motion: faint persistent ink, the replay is the reveal */
      const prev = pts[pts.length - 2];
      if (prev && p.t - prev.t < 150) {
        ctx.strokeStyle = 'rgba(240,237,230,.28)';
        ctx.lineWidth = 1.4 * dpr;
        ctx.beginPath(); ctx.moveTo(prev.x, prev.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      }
    }
  }
  wrap.addEventListener('pointermove', e => add(e.clientX, e.clientY), { passive: true });
  wrap.addEventListener('pointerdown', e => {
    if (e.target === wrap || e.target === cv) add(e.clientX, e.clientY);
  }, { passive: true });

  /* ink that evaporates: segments live FADE ms, tapering as they go */
  function drawFast(list, now, r, g, b, base) {
    for (let i = 1; i < list.length; i++) {
      const a = list[i - 1], p = list[i];
      if (p.t - a.t > 130) continue;
      const age = (now - p.t) / FADE;
      if (age > 1) continue;
      ctx.strokeStyle = `rgba(${r},${g},${b},${(1 - age) * base})`;
      ctx.lineWidth = (2.6 - 1.5 * age) * dpr;
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    }
  }

  function frame() {
    const now = performance.now();
    ctx.clearRect(0, 0, cv.width, cv.height);
    pts = pts.filter(p => now - p.t < BUF_MS);

    /* until a hand arrives, a ghost spark shows the vanishing */
    if (!hasDrawn && !replay) {
      ghostG += 0.028;
      const w = cv.width, h = cv.height;
      ghostPts.push({
        x: w * 0.5 + w * 0.15 * Math.cos(ghostG) + w * 0.07 * Math.cos(2.7 * ghostG + 1),
        y: h * 0.42 + h * 0.15 * Math.sin(1.3 * ghostG) + h * 0.06 * Math.sin(3.1 * ghostG),
        t: now,
      });
      ghostPts = ghostPts.filter(p => now - p.t < FADE);
      drawFast(ghostPts, now, 160, 152, 140, 0.4);
    }

    if (replay) {
      const el = (now - replay.start) * 2.2;
      const headT = replay.t0 + el;
      let fadeMul = 1;
      if (headT >= replay.tEnd) {
        if (!replay.holdAt) replay.holdAt = now;
        const held = now - replay.holdAt;
        if (held > 1400) fadeMul = Math.max(0, 1 - (held - 1400) / 600);
      }
      /* the saved past is retraced and STAYS - only the present vanishes */
      let head = null;
      for (let i = 1; i < replay.pts.length; i++) {
        const a = replay.pts[i - 1], p = replay.pts[i];
        if (p.t > headT) break;
        head = p;
        if (p.t - a.t > 130) continue;
        ctx.strokeStyle = `rgba(255,170,90,${0.8 * fadeMul})`;
        ctx.lineWidth = 2.4 * dpr;
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      }
      if (head && headT < replay.tEnd) {
        ctx.fillStyle = 'rgba(255,122,51,.95)';
        ctx.beginPath(); ctx.arc(head.x, head.y, 3 * dpr, 0, 7); ctx.fill();
      }
      if (fadeMul <= 0) { replay = null; back.hidden = true; }
    } else {
      drawFast(pts, now, 240, 237, 230, 0.85);
      const last = pts[pts.length - 1];
      if (last && now - last.t < 90) {
        ctx.fillStyle = 'rgba(240,237,230,.9)';
        ctx.beginPath(); ctx.arc(last.x, last.y, 2.4 * dpr, 0, 7); ctx.fill();
      }
    }

    /* the quiet tell: it is holding what you can no longer see */
    if (!replay && hasDrawn && pts.length) {
      const held = Math.min(10, Math.floor((now - pts[0].t) / 1000));
      hold.hidden = false;
      hold.textContent = 'HOLDING · 0:' + String(held).padStart(2, '0');
    } else {
      hold.hidden = true;
    }
    press.classList.toggle('ready',
      !replay && pts.length > 5 && pts[pts.length - 1].t - pts[0].t > 1200);

    requestAnimationFrame(frame);
  }
  if (!reduced) requestAnimationFrame(frame);

  function flashHint(txt) {
    hint.textContent = txt;
    hint.style.opacity = '1';
    setTimeout(() => { if (hasDrawn) hint.style.opacity = '0'; }, 1300);
  }

  press.addEventListener('click', () => {
    if (replay) return;
    if (pts.length < 6 || pts[pts.length - 1].t - pts[0].t < 500) {
      flashHint('DRAW FIRST');
      return;
    }
    replay = {
      start: performance.now(),
      pts: pts.slice(),
      t0: pts[0].t,
      tEnd: pts[pts.length - 1].t,
    };
    const secs = Math.max(1, Math.round((replay.tEnd - replay.t0) / 1000));
    after.hidden = false;
    came.hidden = false;
    came.textContent = 'IT BROUGHT BACK ' + secs + ' SECOND' + (secs === 1 ? '' : 'S') +
      ' YOU COULD NO LONGER SEE';
    back.hidden = false;
    tie.hidden = false;
    hold.hidden = true;
    lead.style.opacity = '0';
    press.classList.remove('ready');
    if (reduced) {
      /* no motion: the vanished gesture appears whole, holds, then clears */
      ctx.clearRect(0, 0, cv.width, cv.height);
      for (let i = 1; i < replay.pts.length; i++) {
        const a = replay.pts[i - 1], p = replay.pts[i];
        if (p.t - a.t > 130) continue;
        ctx.strokeStyle = 'rgba(255,170,90,.8)';
        ctx.lineWidth = 2.4 * dpr;
        ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      }
      setTimeout(() => {
        ctx.clearRect(0, 0, cv.width, cv.height);
        replay = null; back.hidden = true;
      }, 2600);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["device-specs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const t = document.getElementById('nerd-toggle');
  const list = document.getElementById('specs-list');
  if (!t) return;
  /* the full spec arrives as a cascade, not a dump */
  [...list.querySelectorAll('.row.nerd')].forEach((r, i) => r.style.setProperty('--i', i));
  t.addEventListener('click', () => {
    const on = t.getAttribute('aria-pressed') !== 'true';
    t.setAttribute('aria-pressed', String(on));
    list.classList.toggle('nerd-on', on);
  });

  /* the sticky bar wears the room; keep its glow aligned as it moves */
  const head = document.getElementById('spec-head');
  if (head) {
    const place = () => {
      const r = head.getBoundingClientRect();
      head.style.setProperty('--rx', r.left.toFixed(1) + 'px');
      head.style.setProperty('--ry', r.top.toFixed(1) + 'px');
      head.style.setProperty('--ry-below', r.bottom.toFixed(1) + 'px');
    };
    addEventListener('scroll', place, { passive: true });
    addEventListener('resize', place);
    place();
  }

  /* the window, alive under the title */
  const rail = document.getElementById('dv-rail');
  if (!rail) return;
  const ctx = rail.getContext('2d');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let dpr = 1;
  function size() {
    dpr = Math.min(devicePixelRatio || 1, 2);
    rail.width = rail.clientWidth * dpr; rail.height = rail.clientHeight * dpr;
    if (reduced) draw(0);
  }
  function draw(ts) {
    const w = rail.width, h = rail.height, mid = h / 2;
    const n = 110, tw = w / n;
    const b0 = w * 0.56, b1 = w * 0.86;
    ctx.clearRect(0, 0, w, h);
    for (let i = 0; i < n; i++) {
      const x = i * tw + tw / 2;
      const ph = i * 0.47 - ts * 0.0011;
      const a = Math.abs(Math.sin(ph)) * 0.75 + 0.25;
      const hgt = a * mid * 0.84 * (0.5 + 0.5 * Math.abs(Math.sin(i * 1.7 + 1)));
      let alpha = 0.1 + 0.26 * a;
      if (x > b0 && x < b1) alpha = Math.min(0.7, alpha * 2.2);
      ctx.strokeStyle = `rgba(222,146,86,${alpha})`;
      ctx.lineWidth = Math.max(1, tw * 0.38);
      ctx.beginPath(); ctx.moveTo(x, mid - hgt); ctx.lineTo(x, mid + hgt); ctx.stroke();
    }
    ctx.fillStyle = 'rgba(222,146,86,.08)';
    ctx.fillRect(b0, 2, b1 - b0, h - 4);
    ctx.fillStyle = 'rgba(240,237,230,.85)';
    ctx.fillRect(b1 - 0.75 * dpr, mid - 10 * dpr, 1.5 * dpr, 20 * dpr);
    if (!reduced) requestAnimationFrame(draw);
  }
  size(); addEventListener('resize', size);
  if (!reduced) requestAnimationFrame(draw); else draw(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["film"] && !Shopify.designMode) return;
  try {
    
(() => {
  const v = document.getElementById('film-video');
  const play = document.getElementById('film-play');
  const bar = document.getElementById('film-bar');
  const track = document.getElementById('film-track');
  const fill = document.getElementById('film-fill');
  const clock = document.getElementById('film-clock');
  if (!v) return;
  const mss = s => Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');
  let started = false;
  play.addEventListener('click', () => {
    play.hidden = true;
    bar.hidden = false;
    started = true;
    v.play().catch(() => { play.hidden = false; bar.hidden = true; started = false; });
  });
  /* the film itself is the pause control once it is running */
  v.addEventListener('click', () => {
    if (!started) return;
    if (v.paused) v.play(); else v.pause();
  });
  v.addEventListener('timeupdate', () => {
    if (!v.duration) return;
    fill.style.width = (v.currentTime / v.duration * 100).toFixed(2) + '%';
    clock.textContent = mss(v.currentTime) + ' / ' + mss(v.duration);
  });
  track.addEventListener('click', e => {
    if (!v.duration) return;
    const r = track.getBoundingClientRect();
    v.currentTime = Math.min(0.995, Math.max(0, (e.clientX - r.left) / r.width)) * v.duration;
    if (v.paused && started) v.play();
  });
  v.addEventListener('ended', () => {
    play.hidden = false;
    bar.hidden = true;
    started = false;
  });
  /* scrolled away mid-play: the sound must not follow the visitor */
  const io = new IntersectionObserver(es => {
    es.forEach(x => { if (!x.isIntersecting && !v.paused) v.pause(); });
  }, { threshold: 0.2 });
  io.observe(v);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-countdown"] && !Shopify.designMode) return;
  try {
    
(() => {
  const count = document.getElementById('count');
  /* a malformed launch setting must never paint NaN into the cells */
  const parsed = new Date(count.dataset.launch).getTime();
  const target = Number.isFinite(parsed) ? parsed : 0;
  const motionMq = matchMedia('(prefers-reduced-motion: reduce)');
  let reduced = motionMq.matches;
  motionMq.addEventListener('change', e => { reduced = e.matches; });
  const echoEl = document.getElementById('hero-echo');
  const agoEl = document.getElementById('hero-ago');
  const heldEl = document.getElementById('hero-held');
  const railWrap = document.getElementById('rail-wrap');
  const rewind = !!railWrap;
  const rail = document.getElementById('rail');
  const rctx = rewind ? rail.getContext('2d') : null;

  /* a launch set 100+ days out gets a third day cell; never a truncated
     reading on the one surface whose claim is exactness */
  const initialDays = Math.floor(Math.max(0, target - Date.now()) / 86400000);
  const cells = {};
  for (const u of ['d','h','m','s']) {
    const host = count.querySelector(`[data-u="${u}"]`);
    const n = u === 'd' ? Math.max(2, String(initialDays).length) : 2;
    cells[u] = Array.from({ length: n }, () => {
      const c = document.createElement('div'); c.className = 'dcell';
      const s = document.createElement('span'); s.textContent = '0';
      c.appendChild(s); host.appendChild(c); return c;
    });
  }

  function setDigit(cell, ch, mode) {
    const cur = cell.querySelector('span:not(.out)');
    if (cur && cur.textContent === ch) return;
    if (cur && mode !== 'none' && !reduced) {
      cur.classList.add('out');
      cur.addEventListener('animationend', () => cur.remove(), { once: true });
      /* backgrounded tabs may never fire animationend; never let spans pile */
      setTimeout(() => cur.remove(), 400);
      const nx = document.createElement('span');
      nx.textContent = ch;
      nx.className = mode === 'rev' ? 'in rev' : 'in';
      cell.appendChild(nx);
    } else {
      cell.querySelectorAll('span').forEach(s => s.remove());
      const nx = document.createElement('span'); nx.textContent = ch; cell.appendChild(nx);
    }
  }

  /* one render path: the countdown as it read at atMs. Scrubbed renders
     pass 'rev' so the digits seat from above - time arriving backward. */
  let first = true, lastSec = null, lastAnim = 0;
  function renderAt(atMs, wantMode) {
    const sec = Math.floor(atMs / 1000);
    if (!first && sec === lastSec) return;
    let left = Math.max(0, target - atMs);
    const d = Math.floor(left / 86400000); left -= d * 86400000;
    const h = Math.floor(left / 3600000);  left -= h * 3600000;
    const m = Math.floor(left / 60000);    left -= m * 60000;
    const s = Math.floor(left / 1000);
    let mode = first ? 'none' : wantMode;
    if (mode !== 'none') {
      const pn = performance.now();
      /* a jump of several seconds (fast drag, catch-up) swaps instantly;
         a stream of single steps gets the seat animation, in the direction
         the viewed moment actually moved - never the caller's guess */
      if (lastSec !== null && Math.abs(sec - lastSec) > 1) mode = 'none';
      else if (pn - lastAnim < 80) mode = 'none';
      else { lastAnim = pn; mode = sec > lastSec ? 'fwd' : 'rev'; }
    }
    lastSec = sec;
    const v = { d, h, m, s };
    for (const u of ['d','h','m','s']) {
      const str = String(v[u]).padStart(cells[u].length, '0');
      cells[u].forEach((c, i) => setDigit(c, str[i], mode));
    }
    first = false;
  }

  /* the scrub: offset seconds behind live, 0 = live. PXS adapts to the
     rail's real width so one full-width gesture reaches 30s on any phone */
  const t0 = Date.now(), MAXBACK = 30;
  let PXS = 11;
  let offset = 0, dragging = false, releasing = false;

  function fmtMS(s) {
    s = Math.max(0, Math.floor(s));
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  }

  /* the cargo of the rewind: lines that appear by the rail for a couple of
     seconds and vanish - short enough to miss, often enough that reaching
     back always finds one. The schedule is fixed against page-open time,
     so a scrubbed moment re-shows exactly the line that was showing then.
     The first waits for the twist under the slogan to land (about 5s). */
  const ECHO = [
    { at: 6,  text: 'Life moves fast.' },
    { at: 11, text: 'Most moments are only obvious afterward.' },
    { at: 16, text: 'By the time you know you needed it, it is usually gone.' },
    { at: 21, text: 'On this page, the last 30 seconds are always within reach.' },
    { at: 26, text: 'On the device, it is the last 30 minutes of sound.' },
    { at: 31, text: 'You could not have known you would want it. It is there anyway.' },
    { at: 36, text: 'Witnuss lets you save the past, just in case it matters later.' },
  ];
  const EWIN = 2, CYCLE = 40;
  function echoState(sinceS) {
    const c = ((sinceS % CYCLE) + CYCLE) % CYCLE;
    for (const e of ECHO) {
      const p = c - e.at;
      if (p >= 0 && p <= EWIN) {
        const a = p < 0.25 ? p / 0.25
          : p > EWIN - 0.25 ? Math.max(0, (EWIN - p) / 0.25) : 1;
        return { text: e.text, a };
      }
    }
    return null;
  }
  /* the caption under the rail says why the rail is there: what the page
     keeps; then, once, right after a line goes ('missed'); then, once, what
     reaching back for one was ('payoff'). The missed hint retires after
     20s, well inside the 30s that still hold the line it points at, so it
     is never false. */
  const capEl = document.getElementById('hero-cap');
  const capText = rewind
    ? { idle: capEl.textContent, missed: capEl.dataset.missed, payoff: capEl.dataset.payoff } : {};
  let capNow = 'idle', capFade = 0, capBack = 0;
  let wasShowing = false, missedShown = false, touched = false, recovered = false, paidOff = false;
  function setCap(k) {
    if (k === capNow || !capText[k]) return;
    capNow = k;
    clearTimeout(capFade);
    const apply = () => {
      capEl.textContent = capText[k];
      capEl.classList.toggle('missed', k === 'missed');
      capEl.classList.toggle('payoff', k === 'payoff');
      capEl.style.opacity = '';
    };
    if (reduced) { apply(); return; }
    capEl.style.opacity = '0';
    capFade = setTimeout(apply, 180);
  }
  function touch() { touched = true; clearTimeout(capBack); }
  function settleCap() {
    clearTimeout(capBack);
    if (recovered && !paidOff) { paidOff = true; setCap('payoff'); }
    if (capNow === 'payoff') capBack = setTimeout(() => setCap('idle'), 6000);
    else setCap('idle');
  }

  function renderEcho() {
    const sinceS = (Date.now() - offset * 1000 - t0) / 1000;
    const st = sinceS < 0 ? null : echoState(sinceS);
    if (st) {
      if (echoEl.textContent !== st.text) echoEl.textContent = st.text;
      echoEl.style.opacity = st.a.toFixed(3);
    } else {
      echoEl.style.opacity = '0';
    }
    if (offset >= 1 && st && st.a > 0.5) {
      const live = echoState((Date.now() - t0) / 1000);
      if (!live || live.text !== st.text) recovered = true;
    }
    if (offset === 0 && !dragging) {
      if (wasShowing && !st && !touched && !missedShown) {
        missedShown = true;
        setCap('missed');
        capBack = setTimeout(() => { if (capNow === 'missed') setCap('idle'); }, 20000);
      }
      wasShowing = !!st;
    }
  }
  function updateAgo() {
    if (!rewind) return;
    /* the plaque states the integer gap between the shown reading and the
       live one, with the same floors the digits use - it must never claim
       a second the countdown is not actually showing */
    const a = (target - Date.now()) / 1000;
    const os = Math.floor(a + offset) - Math.floor(a);
    if (os >= 1) {
      agoEl.hidden = false;
      agoEl.textContent = 'AS OF ' + fmtMS(os) + ' AGO';
    } else {
      agoEl.hidden = true;
    }
    railWrap.setAttribute('aria-valuenow', String(os));
    railWrap.setAttribute('aria-valuetext',
      os >= 1 ? os + (os === 1 ? ' second back' : ' seconds back') : 'live');
  }

  function release() {
    if (dragging || releasing) return;
    if (touched) settleCap();
    if (offset <= 0) { offset = 0; updateAgo(); return; }
    if (reduced) {
      offset = 0; releasing = false;
      renderAt(Date.now(), 'none'); updateAgo(); drawRail();
      return;
    }
    const from = offset, dur = 250 + from * 14;
    const rt0 = performance.now();
    releasing = true;
    (function step(ts) {
      if (!releasing) return;
      const p = Math.min(1, (ts - rt0) / dur);
      offset = from * (1 - p * p);
      if (p < 1) {
        renderAt(Date.now() - offset * 1000, 'none');
        requestAnimationFrame(step);
      } else {
        offset = 0; releasing = false;
        renderAt(Date.now(), 'fwd');
      }
      updateAgo();
    })(rt0);
  }

  if (rewind) {
    /* drag the rail right: the tape follows the finger, pulling the past back
       toward the gate. Pixels become seconds, capped at 30 */
    let startX = 0, startOff = 0, pid = null;
    railWrap.addEventListener('pointerdown', e => {
      if (pid !== null) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      releasing = false;
      touch();
      pid = e.pointerId;
      dragging = true; startX = e.clientX; startOff = offset;
      railWrap.setPointerCapture(e.pointerId);
      e.preventDefault();
      railWrap.classList.add('by-pointer');
      railWrap.focus({ preventScroll: true });
    });
    railWrap.addEventListener('pointermove', e => {
      if (!dragging || e.pointerId !== pid) return;
      offset = Math.min(MAXBACK, Math.max(0, startOff + (e.clientX - startX) / PXS));
      renderAt(Date.now() - offset * 1000, 'rev');
      updateAgo();
      if (reduced) { drawRail(); renderEcho(); }
    });
    const endDrag = e => {
      if (!dragging || e.pointerId !== pid) return;
      dragging = false; pid = null;
      release();
    };
    railWrap.addEventListener('pointerup', endDrag);
    railWrap.addEventListener('pointercancel', endDrag);
    railWrap.addEventListener('keydown', e => {
      if (dragging) return;
      railWrap.classList.remove('by-pointer');
      if (e.key === 'ArrowRight') {
        releasing = false;
        touch();
        offset = Math.min(MAXBACK, offset + 1);
        renderAt(Date.now() - offset * 1000, 'rev');
      } else if (e.key === 'ArrowLeft') {
        releasing = false;
        offset = Math.max(0, offset - 1);
        renderAt(Date.now() - offset * 1000, 'fwd');
      } else if (e.key === 'End') {
        releasing = false;
        touch();
        offset = MAXBACK;
        renderAt(Date.now() - offset * 1000, 'rev');
      } else if (e.key === 'Home' || e.key === 'Escape' || e.key === 'Enter') {
        release();
      } else return;
      e.preventDefault();
      updateAgo();
      if (reduced) { drawRail(); renderEcho(); }
    });
    railWrap.addEventListener('blur', () => { if (!dragging) release(); });
  }

  /* the second rail: future ticks arrive from the right, cross the NOW
     gate with a seal flash, and rest in the warm held trail. While
     scrubbed, the span between your moment and live reads orange - the
     stretch a human reached back over - and a dot marks live. */
  let dpr = 1;
  function sizeRail() {
    dpr = Math.min(devicePixelRatio || 1, 2);
    rail.width = rail.clientWidth * dpr;
    rail.height = rail.clientHeight * dpr;
    PXS = Math.min(11, (rail.clientWidth * 0.85) / MAXBACK);
    if (reduced) drawRail();
  }
  function drawRail() {
    const w = rail.width, hh = rail.height, mid = hh / 2;
    const gate = w * 0.5, px = PXS * dpr;
    rctx.clearRect(0, 0, w, hh);
    rctx.fillStyle = 'rgba(66,60,51,.8)';
    rctx.fillRect(0, mid - 0.5 * dpr, w, 1 * dpr);
    /* under reduced motion the rail steps once per second instead of
       crawling at tick rate, which is motion without meaning */
    const realNow = reduced ? Math.floor(Date.now() / 1000) : Date.now() / 1000;
    const viewNow = realNow - offset;
    const from = Math.floor(viewNow - gate / px) - 1;
    const to = Math.ceil(viewNow + (w - gate) / px) + 1;
    for (let t = from; t <= to; t++) {
      let x = gate + (t - viewNow) * px;
      if (x < -4 || x > w + 4) continue;
      if (dpr === 1) x = Math.round(x) + 0.5;
      const decade = t % 10 === 0;
      let hgt, col;
      if (t > viewNow && t <= realNow) {
        col = 'rgba(255,122,51,.55)';
        hgt = decade ? 7 * dpr : 5 * dpr;
      } else if (t > viewNow) {
        col = 'rgba(125,119,110,.5)';
        hgt = decade ? 7 * dpr : 4.5 * dpr;
      } else {
        const age = viewNow - t;
        col = `rgba(190,184,174,${Math.max(0.14, 0.6 - age * 0.016)})`;
        hgt = decade ? 7.5 * dpr : 5.5 * dpr;
      }
      rctx.strokeStyle = col;
      rctx.lineWidth = dpr === 1 ? 1 : 1.1 * dpr;
      rctx.beginPath();
      rctx.moveTo(x, mid - hgt); rctx.lineTo(x, mid + hgt);
      rctx.stroke();
    }
    rctx.fillStyle = 'rgba(240,237,230,.85)';
    rctx.fillRect(gate - 0.75 * dpr, mid - 9 * dpr, 1.5 * dpr, 18 * dpr);
    const frac = viewNow - Math.floor(viewNow);
    const fa = Math.max(0, 1 - frac / 0.32);
    if (fa > 0 && !reduced) {
      rctx.strokeStyle = `rgba(205,196,178,${fa * 0.7})`;
      rctx.lineWidth = 1.2 * dpr;
      rctx.beginPath();
      rctx.arc(gate, mid, (4 + 8 * (1 - fa)) * dpr, 0, 7);
      rctx.stroke();
    }
    if (offset > 0.2) {
      /* held-trail tone: the gate stays the brightest machine mark */
      const lx = Math.min(gate + offset * px, w - 3 * dpr);
      rctx.fillStyle = 'rgba(190,184,174,.8)';
      rctx.beginPath(); rctx.arc(lx, mid, 2 * dpr, 0, 7); rctx.fill();
    }
    /* marks where a line spoke: only once it has actually happened - the
       future side of the rail never reveals what is coming */
    const t0S = t0 / 1000;
    const fromT = viewNow - gate / px, toT = viewNow + (w - gate) / px;
    rctx.fillStyle = 'rgba(205,196,178,.8)';
    for (const e of ECHO) {
      const k0 = Math.floor((fromT - t0S - e.at) / CYCLE);
      const k1 = Math.ceil((toT - t0S - e.at) / CYCLE);
      for (let k = Math.max(0, k0); k <= k1; k++) {
        const mSec = t0S + k * CYCLE + e.at;
        if (mSec > realNow) continue;
        const x = gate + (mSec - viewNow) * px;
        if (x < -4 || x > w + 4) continue;
        rctx.beginPath(); rctx.arc(x, mid - 10 * dpr, 1.7 * dpr, 0, 7); rctx.fill();
      }
    }
  }
  function railLoop() { drawRail(); renderEcho(); requestAnimationFrame(railLoop); }
  if (rewind) {
    sizeRail();
    addEventListener('resize', sizeRail);
    if (!reduced) requestAnimationFrame(railLoop);
  }

  function tick() {
    /* parked or live, the viewed moment advances forward; only the scrub
       handlers themselves render in reverse */
    if (!dragging && !releasing) renderAt(Date.now() - offset * 1000, 'fwd');
    else if (dragging) renderAt(Date.now() - offset * 1000, 'rev');
    const n = new Date();
    const nowEl = document.getElementById('hero-now');
    if (nowEl) nowEl.textContent =
      [n.getHours(), n.getMinutes(), n.getSeconds()].map(x => String(x).padStart(2,'0')).join(':');
    const heldS = Math.floor((Date.now() - t0) / 1000);
    heldEl.textContent = heldS >= 3600
      ? Math.floor(heldS / 3600) + ':' + String(Math.floor(heldS / 60) % 60).padStart(2, '0') +
        ':' + String(heldS % 60).padStart(2, '0')
      : fmtMS(heldS);
    updateAgo();
    if (reduced && rewind) { drawRail(); renderEcho(); }
  }
  tick();
  setInterval(tick, 250);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press"] && !Shopify.designMode) return;
  try {
    
(() => {
  function copy(text, el) {
    const done = () => {
      const was = el.textContent;
      el.classList.add('done'); el.textContent = 'COPIED';
      setTimeout(() => { el.classList.remove('done'); el.textContent = was; }, 1400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, () => {});
    } else {
      const t = document.createElement('textarea');
      t.value = text; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); done(); } catch (_) {}
      t.remove();
    }
  }
  document.querySelectorAll('.pr [data-copy]').forEach(b =>
    b.addEventListener('click', () => copy(b.dataset.copy, b)));
  document.querySelectorAll('.pr [data-copy-from]').forEach(b =>
    b.addEventListener('click', () => {
      const src = document.getElementById(b.dataset.copyFrom);
      if (src) copy(src.textContent.trim(), b);
    }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["record-audit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wrap = document.getElementById('rec-wavewrap');
  const wave = document.getElementById('rec-wave');
  const chip = document.getElementById('rec-chip');
  const feed = document.getElementById('rec-feed');
  const status = document.getElementById('rec-status');
  const cap = document.getElementById('rec-caption');
  const caplT = document.getElementById('rec-capl-t');
  const capR = document.getElementById('rec-capr');
  const dot = document.getElementById('rec-dot');
  const bPress = document.getElementById('rec-press');
  const bCut = document.getElementById('rec-cut');
  const bHeal = document.getElementById('rec-heal');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ctx = wave.getContext('2d');

  /* phones get a shorter record so the stage, keys and caption share
     one screen; nothing explanatory may live a scroll away */
  const ROWCAP = matchMedia('(max-width: 560px)').matches ? 4 : 6;
  /* 0 = listening (live since page load), 1 = saved, 2 = edited.
     gen voids a state's pending timeouts the moment the state changes;
     swapAt stops a double click from actuating the replacement button. */
  let state = 0, gen = 0, swapAt = 0;
  const t0 = Date.now();
  let pressAt = null;
  function swapGuard() {
    const now = performance.now();
    if (now - swapAt < 350) return false;
    swapAt = now; gen++;
    return true;
  }

  let seed = 7104;
  function rnd() { seed = (seed * 1103515245 + 12345) % 2147483648; return seed / 2147483648; }
  function hex(n) { let s = ''; for (let i = 0; i < n; i++) s += '0123456789abcdef'[Math.floor(rnd() * 16)]; return s; }
  function fmt(d) {
    let h = d.getHours();
    const am = h < 12 ? ' AM' : ' PM'; h = h % 12 || 12;
    return h + ':' + String(d.getMinutes()).padStart(2, '0') + ':' + String(d.getSeconds()).padStart(2, '0') + am;
  }
  function fmtAge(ms) {
    const s = Math.max(1, Math.round(ms / 1000));
    return s < 60 ? s + ' S' : Math.floor(s / 60) + ' MIN' + (s % 60 ? ' ' + (s % 60) + ' S' : '');
  }
  function fmtAgeLong(ms) {
    const s = Math.max(1, Math.round(ms / 1000));
    const m = Math.floor(s / 60), r = s % 60;
    const sec = x => x + (x === 1 ? ' second' : ' seconds');
    if (m === 0) return sec(s);
    const min = m + (m === 1 ? ' minute' : ' minutes');
    return r === 0 ? min : min + ' ' + sec(r);
  }

  /* the sound line: flows while listening, holds still once saved */
  let dpr = 1, cutA = -1, cutB = -1, prevA = -1, prevB = -1, frozenAt = 0, pausedTotal = 0;
  function sizeWave() {
    dpr = Math.min(devicePixelRatio || 1, 2);
    wave.width = wave.clientWidth * dpr; wave.height = wave.clientHeight * dpr;
    if (reduced || state > 0) drawWave(performance.now());
  }
  sizeWave(); addEventListener('resize', sizeWave);
  function drawWave(ts) {
    const eff = reduced ? 0 : (state > 0 ? frozenAt : ts) - pausedTotal;
    const flow = eff * 0.00012;
    ctx.clearRect(0, 0, wave.width, wave.height);
    const n = 90, w = wave.width / n, mid = wave.height / 2;
    for (let i = 0; i < n; i++) {
      const x = i * w + w / 2;
      const ph = i * 0.47 - flow * 34;
      const a = Math.abs(Math.sin(ph)) * 0.75 + 0.25;
      const hgt = a * mid * 0.86 * (0.5 + 0.5 * Math.abs(Math.sin(i * 1.7 + 1)));
      if (cutA >= 0 && i / n > cutA && i / n < cutB) continue;
      /* the sound is the living thing: warm ember, not grey ivory */
      ctx.strokeStyle = `rgba(222,146,86,${(0.14 + 0.34 * a) * (state === 2 ? 0.55 : 1)})`;
      ctx.lineWidth = Math.max(1, w * 0.4);
      ctx.beginPath(); ctx.moveTo(x, mid - hgt); ctx.lineTo(x, mid + hgt); ctx.stroke();
    }
    if (state > 0) {
      /* the press, marked where it landed: the right edge, that second */
      const px = wave.width - 3 * dpr;
      ctx.strokeStyle = 'rgba(255,122,51,.9)';
      ctx.lineWidth = 1.6 * dpr;
      ctx.beginPath(); ctx.moveTo(px, 2); ctx.lineTo(px, wave.height - 2); ctx.stroke();
      ctx.fillStyle = 'rgba(255,122,51,.9)';
      ctx.beginPath(); ctx.arc(px, 5 * dpr, 2.4 * dpr, 0, 7); ctx.fill();
    }
    if (prevA >= 0 && cutA < 0) {
      /* the cut, previewed under the finger before it commits; neutral
         until it is real - red belongs to the mismatch alone */
      const x0 = wave.width * Math.min(prevA, prevB), x1 = wave.width * Math.max(prevA, prevB);
      ctx.fillStyle = 'rgba(190,184,174,.08)';
      ctx.fillRect(x0, 0, Math.max(2, x1 - x0), wave.height);
      ctx.strokeStyle = 'rgba(190,184,174,.55)';
      ctx.lineWidth = 1.2 * dpr;
      ctx.setLineDash([4 * dpr, 4 * dpr]);
      ctx.beginPath(); ctx.moveTo(x0, 2); ctx.lineTo(x0, wave.height - 2); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x1, 2); ctx.lineTo(x1, wave.height - 2); ctx.stroke();
      ctx.setLineDash([]);
    }
    if (cutA >= 0) {
      const x0 = wave.width * cutA, x1 = wave.width * cutB;
      ctx.strokeStyle = 'rgba(255,107,107,.9)';
      ctx.lineWidth = 1.4 * dpr;
      ctx.setLineDash([5 * dpr, 4 * dpr]);
      ctx.beginPath(); ctx.moveTo(x0, 2); ctx.lineTo(x0, wave.height - 2); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x1, 2); ctx.lineTo(x1, wave.height - 2); ctx.stroke();
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(255,107,107,.85)';
      ctx.font = `600 ${9 * dpr}px ${getComputedStyle(document.body).fontFamily}`;
      ctx.textAlign = 'center';
      ctx.fillText('CUT', (x0 + x1) / 2, 12 * dpr);
    }
  }
  /* one loop only: manual drawWave calls (resize, reduced motion) must
     never fork a second requestAnimationFrame chain */
  function waveLoop(ts) { drawWave(ts); requestAnimationFrame(waveLoop); }
  if (!reduced) requestAnimationFrame(waveLoop); else drawWave(0);

  /* running clock: how long this page has really been listening */
  setInterval(() => {
    if (state !== 0) return;
    const s = Math.floor((Date.now() - t0) / 1000);
    caplT.textContent = 'LIVE ' + Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  }, 1000);

  function row(cls, label, d, h, okTxt, prev) {
    const r = document.createElement('div');
    r.className = 'rec-row ' + cls;
    r.dataset.ts = d.getTime();
    r.innerHTML = '<span class="t">' + label + ' ' + fmt(d) + '</span>' +
      '<span class="h">' + h + '</span>' +
      '<span class="ok">' + okTxt + '</span>' +
      (prev ? '<span class="lk">LOCKS ' + fmt(prev) + '</span>' : '');
    return r;
  }
  function dropChip(txt, done) {
    if (reduced) { done(); return; }
    chip.hidden = false;
    chip.textContent = txt;
    chip.style.transition = 'none';
    chip.style.opacity = '1';
    chip.style.left = '46%'; chip.style.top = '26px';
    chip.style.transform = 'translateY(0)';
    requestAnimationFrame(() => requestAnimationFrame(() => {
      chip.style.transition = '';
      chip.style.transform = 'translateY(96px)';
      chip.style.opacity = '0';
      setTimeout(() => { chip.hidden = true; done(); }, 780);
    }));
  }
  /* prevSeal and firstSealAt only advance when a line actually lands, so
     a press during a falling chip never locks a line that never appeared */
  let prevSeal = null, firstSealAt = null;
  function seal() {
    if (state !== 0) return;
    const now = new Date();
    const h = hex(4) + ' ' + hex(4);
    dropChip(h, () => {
      if (state !== 0) return;
      const prev = prevSeal;
      const r = row('new', 'SEALED', now, h, 'MATCHES', prev);
      if (!prev) r.insertAdjacentHTML('beforeend', '<span class="lk">OPENS THE RECORD</span>');
      feed.prepend(r);
      prevSeal = now;
      if (!firstSealAt) firstSealAt = now;
      while (feed.children.length > ROWCAP) feed.lastChild.remove();
    });
  }
  seal();
  setInterval(seal, reduced ? 6000 : 4000);

  const LIVE_CAP = 'The sound passes; the seals stay, each locking the last. On the device this runs every minute, the whole time it is on.';
  function setCaps(l, r) { if (l !== null) caplT.textContent = l; capR.textContent = r; }

  /* THE PRESS: the save seals the second you press, then checks the record */
  bPress.addEventListener('click', () => {
    if (state !== 0 || !swapGuard()) return;
    const g = gen;
    state = 1;
    pressAt = new Date();
    frozenAt = performance.now();
    chip.hidden = true;
    dot.classList.add('held');
    wrap.classList.add('cuttable');
    bPress.hidden = true; bCut.hidden = false;
    feed.prepend(row('press', 'YOUR PRESS', pressAt, hex(4) + ' ' + hex(4), 'SAVED', prevSeal));
    const rows = [...feed.children];
    const sealed = rows.filter(r => !r.classList.contains('press'));
    setCaps('THE SOUND, AS SAVED', 'DRAG ACROSS THE SOUND TO CUT A PIECE OUT');
    rows.slice().reverse().forEach((r, i) => {
      setTimeout(() => { if (g === gen) r.classList.add('match'); }, 80 + i * 70);
    });
    if (sealed.length) {
      const ageMs = pressAt.getTime() - (firstSealAt ? firstSealAt.getTime() : Number(sealed[sealed.length - 1].dataset.ts));
      setTimeout(() => {
        if (g !== gen) return;
        status.className = 'rec-status good';
        status.textContent = 'EVERY LINE CHECKS OUT · THE RECORD REACHES BACK ' + fmtAge(ageMs) + ' BEFORE YOUR PRESS';
      }, 80 + rows.length * 70 + 120);
      cap.textContent = 'Sealed the second you pressed - and it was all already there, reaching back ' +
        fmtAgeLong(ageMs) +
        '. Now drag across the sound to cut a piece out.';
    } else {
      setTimeout(() => {
        if (g !== gen) return;
        status.className = 'rec-status good';
        status.textContent = 'SAVED · SEALED THE SECOND YOU PRESSED';
      }, 300);
      cap.textContent = 'Sealed the second you pressed. Now drag across the sound to cut a piece out.';
    }
    if (reduced) drawWave(0);
  });

  /* THE EDIT: the visitor cuts the saved sound themselves */
  function frac(e) {
    const r = wave.getBoundingClientRect();
    return Math.min(0.97, Math.max(0.02, (e.clientX - r.left) / r.width));
  }
  function doCut(a, b) {
    if (state !== 1) return;
    gen++;
    const g = gen;
    state = 2;
    dragFrom = null; prevA = prevB = -1;
    cutA = Math.min(a, b); cutB = Math.max(a, b);
    if (cutB - cutA < 0.05) { const c = (cutA + cutB) / 2; cutA = Math.max(0.02, c - 0.045); cutB = Math.min(0.97, c + 0.045); }
    bCut.hidden = true; bHeal.hidden = false;
    wrap.classList.remove('cuttable');
    /* the sound line spans page-open to the press; seals after the cut break */
    const cutTime = t0 + cutA * (pressAt.getTime() - t0);
    let flipped = 0;
    [...feed.children].forEach((r, i) => {
      if (Number(r.dataset.ts) >= cutTime || r.classList.contains('press')) {
        setTimeout(() => {
          if (g !== gen) return;
          r.classList.add('broken');
          r.querySelector('.ok').textContent = 'DOES NOT MATCH';
        }, 120 + flipped * 90);
        flipped++;
      } else {
        /* the minutes before the cut still match; say so at once, since
           the press sweep's pending ticks were just voided */
        r.classList.add('match');
      }
    });
    setTimeout(() => {
      if (g !== gen) return;
      status.className = 'rec-status bad';
      status.textContent = 'THE EDIT SHOWS · NOTHING AFTER ' + fmt(new Date(cutTime)) + ' MATCHES THE RECORD';
    }, 120 + flipped * 90 + 120);
    setCaps(null, 'A PIECE IS MISSING');
    cap.textContent = 'You cut a piece out. Nothing after ' + fmt(new Date(cutTime)).toLowerCase() +
      ' matches now - an edit always shows.';
    if (reduced) drawWave(0);
  }
  let dragFrom = null;
  wave.addEventListener('pointerdown', e => {
    if (state !== 1) return;
    dragFrom = frac(e);
    prevA = prevB = dragFrom;
    wave.setPointerCapture(e.pointerId);
    if (reduced) drawWave(0);
  });
  wave.addEventListener('pointermove', e => {
    if (state !== 1 || dragFrom === null) return;
    prevB = frac(e);
    if (reduced) drawWave(0);
  });
  wave.addEventListener('pointercancel', () => {
    dragFrom = null; prevA = prevB = -1;
    if (reduced) drawWave(0);
  });
  wave.addEventListener('pointerup', e => {
    if (state !== 1 || dragFrom === null) return;
    const f = frac(e), from = dragFrom;
    dragFrom = null; prevA = prevB = -1;
    doCut(from, f);
  });
  bCut.addEventListener('click', () => { if (swapGuard()) doCut(0.55, 0.66); });

  /* PUT IT BACK: undo the edit, listening resumes */
  bHeal.addEventListener('click', () => {
    if (state !== 2 || !swapGuard()) return;
    cutA = cutB = -1;
    dragFrom = null; prevA = prevB = -1;
    pausedTotal += performance.now() - frozenAt;
    state = 0;
    dot.classList.remove('held');
    bHeal.hidden = true; bPress.hidden = false;
    [...feed.children].forEach(r => {
      if (r.classList.contains('press')) { r.remove(); return; }
      r.classList.remove('broken', 'match');
      r.querySelector('.ok').textContent = 'MATCHES';
    });
    status.className = 'rec-status';
    status.textContent = 'THE RECORD · EACH LINE LOCKS THE ONE BEFORE';
    setCaps('LIVE', 'EVERY FEW SECONDS, A SEAL DROPS INTO THE RECORD');
    cap.textContent = 'Back in place. It matches again - and the record is building.';
    if (reduced) drawWave(0);
  });

  cap.textContent = LIVE_CAP;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sick-of-this"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('sick');
  if (!root) return;
  let data = { sums: '', notes: '', answers: '' };
  try { data = JSON.parse(document.getElementById('sick-data').textContent); } catch (e) {}
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = ms => new Promise(r => setTimeout(r, reduced ? 0 : ms));
  const lines = s => String(s || '').split('\n').map(x => x.trim()).filter(Boolean);
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  /* ACT 1. Moments are separated by a line of ---; a moment's first line
     is "Title | 0:04 · today", the rest are its summary lines. */
  const moments = String(data.sums || '').split(/\n\s*---+\s*\n/).map(b => {
    const ls = lines(b);
    const [theirs, mine] = (ls.shift() || '').split('||');
    const [title, meta] = (theirs || '').split('|').map(s => s.trim());
    const [oTitle, oWhen, oLen] = (mine || '').split('|').map(s => s.trim());
    const [clock, day] = (oWhen || '').split('·').map(s => s.trim());
    return { title, meta: meta || '', lines: ls,
             ours: { title: oTitle || title, clock: clock || '', day: day || '', len: oLen || '' } };
  }).filter(m => m.title && m.lines.length);
  /* our red notes, in the order the gimmicks land: summary, mood, mind
     map, tags, action items, recap, ask-AI */
  const notes = lines(data.notes);
  const act1 = document.getElementById('sk-act1');
  const head1 = document.getElementById('sk-h1');
  const card = document.getElementById('ai-card');
  const bar = document.getElementById('ai-bar');
  const stack = document.getElementById('ai-stack');
  const btn = document.getElementById('ai-btn');
  const stop = document.getElementById('stop-btn');
  const again = document.getElementById('again-btn');
  const tEl = document.getElementById('ai-title');
  const mEl = document.getElementById('ai-meta');
  const spark = document.getElementById('ai-spark');
  const pay = document.getElementById('sick-pay');
  const covers = Array.isArray(data.covers) ? data.covers : [];
  const memImg = document.getElementById('mem-img');
  let mi = 0, run = 0;

  /* the same moment as a saved Memory: set while their pile runs, so the
     cover is loaded by the time the card is shown */
  function memory(m) {
    const i = moments.indexOf(m);
    if (covers.length && memImg) memImg.src = covers[i % covers.length];
    document.getElementById('mem-title').textContent = m.ours.title;
    document.getElementById('mem-clock').textContent = m.ours.clock;
    document.getElementById('mem-day').textContent = m.ours.day.toUpperCase();
    document.getElementById('mem-len').textContent = m.ours.len;
  }

  /* the headings belong to whoever is on screen: theirs until it stops */
  function side(us) {
    if (act1.classList.contains('is-us') === us) return;
    act1.classList.toggle('is-us', us);
    head1.classList.remove('flip'); void head1.offsetWidth; head1.classList.add('flip');
  }

  function plain(m) {
    tEl.textContent = m.title;
    mEl.textContent = m.meta.toUpperCase();
    card.classList.remove('full', 'done', 'shake');
    bar.classList.remove('gone');
    spark.classList.remove('cracked');
    stack.innerHTML = '';
    stack.style.minHeight = '';
    pay.classList.remove('on');
    stop.hidden = true;
    btn.hidden = false;
    btn.disabled = false;
    memory(m);
  }
  if (moments.length) plain(moments[0]);

  /* the pile every recorder sells, in the order it arrives; each gimmick
     carries the index of the red note that lands on it */
  function pile(m) {
    const sum = el('div', 'pc');
    sum.appendChild(el('p', 'lbl', 'AI SUMMARY'));
    for (const l of m.lines) sum.appendChild(el('p', null, l));
    const mood = el('div', 'pc');
    mood.appendChild(el('p', 'lbl', 'MOOD'));
    mood.appendChild(el('p', null, 'Mostly happy · 91%'));
    const mb = el('div', 'mood-bar'); const fill = el('i'); mb.appendChild(fill); mood.appendChild(mb);
    const mind = el('div', 'pc mind');
    mind.appendChild(el('p', 'lbl', 'MIND MAP'));
    mind.insertAdjacentHTML('beforeend',
      '<svg viewBox="0 0 200 74" aria-hidden="true">' +
      '<line x1="100" y1="37" x2="34" y2="14"/><line x1="100" y1="37" x2="166" y2="14"/>' +
      '<line x1="100" y1="37" x2="34" y2="62"/><line x1="100" y1="37" x2="166" y2="62"/>' +
      '<circle class="c" cx="100" cy="37" r="7"/><circle cx="34" cy="14" r="4"/><circle cx="166" cy="14" r="4"/>' +
      '<circle cx="34" cy="62" r="4"/><circle cx="166" cy="62" r="4"/>' +
      '<text x="42" y="11">Feelings</text><text x="116" y="11">Synergy</text>' +
      '<text x="42" y="70">Next steps</text><text x="122" y="70">Growth</text></svg>');
    const row = el('div', 'pc-row');
    row.appendChild(mood); row.appendChild(mind);
    const tags = el('div', 'pc tags');
    for (const t of ['#meeting', '#alignment', '#productivity', '#insight']) tags.appendChild(el('span', null, t));
    const todo = el('div', 'pc');
    todo.appendChild(el('p', 'lbl', 'ACTION ITEMS'));
    const ti = el('div', 'todo'); ti.appendChild(el('b')); ti.appendChild(el('span', null, 'Schedule a follow-up'));
    todo.appendChild(ti);
    const recap = el('div', 'pc recap', '✉ Your daily recap is scheduled for 8:00 AM');
    const ask = el('button', 'pc askp', '✨ Ask AI about this recording');
    ask.type = 'button'; ask.tabIndex = -1;
    const badge = el('div', 'pc badge', 'GENERATED WITH AI ✨');
    const foot = el('div', 'pc-foot');
    foot.appendChild(ask); foot.appendChild(badge);
    return {
      steps: [[sum, [[sum, 0]]], [row, [[mood, 1, 'low'], [mind, 2]]], [tags, [[tags, 3]]],
              [todo, [[todo, 4]]], [recap, [[recap, 5]]], [foot, [[foot, 6]]]],
      fill,
    };
  }

  btn && btn.addEventListener('click', async () => {
    if (!moments.length) return;
    const me = ++run;
    const m = moments[mi % moments.length];
    plain(m);
    btn.classList.remove('lure');
    const pen = btn.querySelector('.pen');
    if (pen) pen.remove();
    btn.disabled = true;
    const shim = el('div', 'pc shim');
    shim.appendChild(el('p', null, 'Extracting insights…'));
    stack.appendChild(shim);
    await wait(1400);
    if (me !== run) return;
    shim.remove();
    btn.hidden = true;
    const { steps, fill } = pile(m);
    for (const [piece, marks] of steps) {
      stack.appendChild(piece);
      if (piece.contains(fill)) requestAnimationFrame(() => { fill.style.width = '91%'; });
      await wait(300);
      if (me !== run) return;
      for (const [host, ni, pos] of marks) {
        if (!notes[ni]) continue;
        host.appendChild(el('span', 'note' + (pos ? ' ' + pos : ''), notes[ni]));
        await wait(260);
        if (me !== run) return;
      }
    }
    card.classList.add('full');
    await wait(300);
    if (me !== run) return;
    stop.hidden = false;
    stop.focus({ preventScroll: true });
    stop.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
  });

  stop && stop.addEventListener('click', async () => {
    const me = ++run;
    stop.hidden = true;
    card.classList.add('shake');
    await wait(420);
    if (me !== run) return;
    // the card holds its size while the pile falls out of it
    stack.style.minHeight = stack.offsetHeight + 'px';
    const parts = [bar, ...stack.querySelectorAll(':scope > .pc, .pc-row > .pc, .pc-foot > .pc, .pc-foot > .note')];
    parts.forEach((p, i) => {
      p.style.setProperty('--dx', ((i % 2 ? 1 : -1) * (30 + Math.random() * 70)).toFixed(0) + 'px');
      p.style.setProperty('--rot', ((i % 2 ? 1 : -1) * (12 + Math.random() * 38)).toFixed(0) + 'deg');
      p.style.setProperty('--dl', (i * 0.07).toFixed(2) + 's');
      p.classList.add('gone');
    });
    spark.classList.add('cracked');
    card.classList.remove('full');
    await wait(1000);
    if (me !== run) return;
    stack.innerHTML = '';
    stack.style.minHeight = '';
    card.classList.remove('shake');
    card.classList.add('done');
    pay.classList.add('on');
    side(true);
    mi++;
    // the flipped headings are part of the answer: bring them into view
    const r = act1.getBoundingClientRect();
    if (r.top < 60 || card.getBoundingClientRect().bottom > innerHeight)
      act1.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
  });

  again && again.addEventListener('click', () => {
    run++;
    side(false);
    if (moments.length) plain(moments[mi % moments.length]);
    btn.focus({ preventScroll: true });
  });

  /* ACT 2, THEIR ASSISTANT: anything typed is shown back, never sent
     anywhere; it answers with exactly what you'd expect, and our stamp
     lands on it. */
  const answers = lines(data.answers);
  const form = document.getElementById('ask-bar');
  const input = document.getElementById('ask-in');
  const log = document.getElementById('ask-log');
  const ours = document.getElementById('ask-ours');
  let asked = 0, busy = false;
  const calm = () => {
    form.classList.remove('lure');
    const pen = form.querySelector('.pen');
    if (pen) pen.remove();
  };
  input && input.addEventListener('focus', calm);
  root.querySelectorAll('#ask-chips .chip').forEach(c => c.addEventListener('click', () => {
    if (busy) return;
    input.value = c.textContent;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true }));
  }));
  form && form.addEventListener('submit', async ev => {
    ev.preventDefault();
    if (!answers.length || busy) return;
    busy = true;
    calm();
    const q = input.value.trim() || 'How was my day?';
    input.value = '';
    const hint = log.querySelector('.ask-hint');
    if (hint) hint.remove();
    log.appendChild(el('p', 'me', q));
    const typing = el('p', 'it typing', '•••');
    log.appendChild(typing);
    while (log.children.length > 4) log.firstElementChild.remove();
    await wait(900);
    typing.remove();
    const it = el('p', 'it');
    it.appendChild(el('span', null, answers[asked % answers.length]));
    log.appendChild(it);
    asked++;
    while (log.children.length > 4) log.firstElementChild.remove();
    await wait(850);
    it.classList.add('struck');
    it.appendChild(el('b', 'bub-stamp', 'NOT ON A WITNUSS'));
    ours.classList.add('on');
    busy = false;
  });

  /* ACT 3, THE SPEC SHEET: stamps fall as the rows arrive; the script arms
     them, so without it every stamp is simply there. */
  const sheet = root.querySelector('.sheet');
  if (!sheet) return;
  const rows = [...sheet.querySelectorAll('.srow')];
  if (reduced || !('IntersectionObserver' in window)) {
    rows.forEach(r => { if (!r.classList.contains('ours')) r.classList.add('struck'); });
    return;
  }
  sheet.classList.add('armed');
  const io = new IntersectionObserver(es => {
    if (!es.some(e => e.isIntersecting)) return;
    io.disconnect();
    rows.forEach((r, i) => setTimeout(() => {
      r.querySelector('.stamp').classList.add('down');
      if (!r.classList.contains('ours')) r.classList.add('struck');
    }, 260 + i * 330));
  }, { threshold: .35 });
  io.observe(sheet);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["so-much-more"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const rows = [...document.querySelectorAll('.wall-row')];
  if (!rows.length) return;
  /* NEVER trust the track's own width: WebKit sizes width:max-content
     from each card's intrinsic 574px (the image's 560 attribute), Chrome
     from the flexed 132px - so any loop math built on scrollWidth sends
     iPhones thousands of pixels into empty track (the blank-row bug, five
     rounds running). Measure the laid-out cards and pin the width. */
  const halves = rows.map(() => 0);
  function measure() {
    rows.forEach((r, i) => {
      const t = r.querySelector('.wall-track');
      const kids = [...t.children];
      if (!kids.length) return;
      const gap = parseFloat(getComputedStyle(t).columnGap) || 22;
      let w = gap * (kids.length - 1);
      kids.forEach(k => { w += k.offsetWidth; });
      t.style.width = w + 'px';
      halves[i] = w / 2;
    });
  }
  measure();
  addEventListener('resize', measure);
  const speed = [0.034, -0.028];
  const acc = rows.map(() => 0);
  const paused = rows.map(() => false);
  rows.forEach((r, i) => {
    r.addEventListener('pointerenter', () => { paused[i] = true; });
    r.addEventListener('pointerleave', () => { paused[i] = false; });
  });
  let last = performance.now();
  function loop(ts) {
    const dt = Math.min(64, ts - last); last = ts;
    rows.forEach((r, i) => {
      const half = halves[i];
      if (!half || half <= r.clientWidth / 2) return;
      if (!paused[i]) acc[i] += dt * speed[i];
      let off = acc[i] % half;
      if (off < 0) off += half;
      r.scrollLeft = off;
    });
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const stage = document.getElementById('dev-canvas');
  const rail = document.getElementById('dev-rail');
  const wrap = document.getElementById('dev-railwrap');
  const dots = [...document.querySelectorAll('.dev-dot')];
  if (!stage || !dots.length) return;
  const sctx = stage.getContext('2d'), rctx = rail.getContext('2d');
  const timeEl = document.getElementById('dev-time');
  const kEl = document.getElementById('dev-k');
  const claimEl = document.getElementById('dev-claim');
  const bodyEl = document.getElementById('dev-body');
  const capEl = document.querySelector('.dev-caption');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const ST = dots.map(d => {
    const h = parseFloat(d.dataset.hour);
    return {
      hour: Number.isFinite(h) ? ((h % 24) + 24) % 24 : 0,
      time: d.dataset.time, label: d.dataset.label,
      claim: d.dataset.claim, body: d.dataset.body, vig: d.dataset.vig,
    };
  });
  const FAM = getComputedStyle(document.body).fontFamily;

  let dpr = 1, nightGrad = null;
  function size() {
    dpr = Math.min(devicePixelRatio || 1, 2);
    for (const c of [stage, rail]) { c.width = c.clientWidth * dpr; c.height = c.clientHeight * dpr; }
    nightGrad = rctx.createLinearGradient(0, 0, rail.width, 0);
    nightGrad.addColorStop(0, 'rgba(0,0,0,.28)'); nightGrad.addColorStop(0.26, 'rgba(0,0,0,0)');
    nightGrad.addColorStop(0.85, 'rgba(0,0,0,0)'); nightGrad.addColorStop(1, 'rgba(0,0,0,.28)');
    if (reduced) paint(performance.now());
  }

  /* the journey: travel to a station, dwell, move on; a drag takes over */
  let cur = -1, dayT = 6.4, enterAt = 0, dragging = false, byHand = false;
  let mode = 'travel', target = 0, travelFrom = 6.4, travelT0 = 0, shortWay = false;
  const TRAVEL = 1700, DWELL = 5200;
  function setStation(i, ts) {
    if (!ST[i]) return;
    if (i === cur) { enterAt = ts; dots[i].classList.toggle('byhand', byHand); return; }
    cur = i; enterAt = ts;
    const s = ST[i];
    timeEl.textContent = s.time; kEl.textContent = s.label;
    claimEl.textContent = s.claim; bodyEl.textContent = s.body;
    dots.forEach((d, k) => {
      d.classList.toggle('on', k === i);
      d.classList.toggle('byhand', k === i && byHand);
    });
    capEl.classList.remove('swap'); void capEl.offsetWidth; capEl.classList.add('swap');
  }
  function stepAuto(ts) {
    if (mode === 'travel') {
      const p = Math.min(1, (ts - travelT0) / TRAVEL);
      const e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      const to = ST[target].hour;
      let delta = to - travelFrom;
      /* a drag release settles the short way; the tour sweeps forward */
      if (shortWay) delta = ((delta % 24) + 36) % 24 - 12;
      else if (delta < 0) delta += 24;
      dayT = ((travelFrom + delta * e) % 24 + 24) % 24;
      if (p >= 1) { setStation(target, ts); mode = 'dwell'; shortWay = false; }
    } else if (ts - enterAt > DWELL) {
      byHand = false;
      travelFrom = dayT; travelT0 = ts; target = (cur + 1) % ST.length; mode = 'travel';
    }
  }
  function nearest(h) {
    let best = -1, bd = 1e9;
    ST.forEach((s, i) => { const d = Math.min(Math.abs(s.hour - h), 24 - Math.abs(s.hour - h)); if (d < bd) { bd = d; best = i; } });
    return { i: best, d: bd };
  }

  /* ---- the stage: one vignette per station, drawn in ticks and seals */
  const EMBER = (a) => `rgba(222,146,86,${a})`;
  const GREEN = (a) => `rgba(143,201,143,${a})`;
  const VIOLET = (a) => `rgba(158,124,255,${a})`;
  function ticks(w, h, t, opts = {}) {
    const n = 64, tw = w / n, mid = h / 2;
    for (let i = 0; i < n; i++) {
      const x = i * tw + tw / 2;
      if (opts.flatFrom !== undefined && x > opts.flatFrom) continue;
      const ph = i * 0.49 - t * 2.1;
      const a = Math.abs(Math.sin(ph)) * 0.75 + 0.25;
      let hgt = a * mid * 0.8 * (0.5 + 0.5 * Math.abs(Math.sin(i * 1.7 + 1)));
      let alpha = (0.12 + 0.3 * a) * (opts.dim || 1);
      if (opts.band && x > opts.band[0] && x < opts.band[1]) alpha = Math.min(0.75, alpha * 2.1);
      sctx.strokeStyle = EMBER(alpha);
      sctx.lineWidth = Math.max(1, tw * 0.38);
      sctx.beginPath(); sctx.moveTo(x, mid - hgt); sctx.lineTo(x, mid + hgt); sctx.stroke();
    }
  }
  function sealRing(x, y, p, col) {
    const a = Math.max(0, 1 - p);
    if (a <= 0) return;
    sctx.strokeStyle = col(a * 0.8);
    sctx.lineWidth = 1.2 * dpr;
    sctx.beginPath(); sctx.arc(x, y, (4 + 10 * p) * dpr, 0, 7); sctx.stroke();
  }
  function flag(x, h, col, label) {
    const mid = h / 2;
    sctx.strokeStyle = col(0.9); sctx.lineWidth = 1.5 * dpr;
    sctx.beginPath(); sctx.moveTo(x, mid - h * 0.38); sctx.lineTo(x, mid + h * 0.38); sctx.stroke();
    if (label) {
      sctx.fillStyle = col(0.85);
      sctx.font = `600 ${9 * dpr}px ${FAM}`;
      try { sctx.letterSpacing = `${1.2 * dpr}px`; } catch (_) {}
      sctx.textAlign = 'center';
      sctx.fillText(label, x, mid - h * 0.38 - 5 * dpr);
    }
  }
  const VIGS = {
    sched(w, h, t) {
      ticks(w, h, t * 0.4, { band: [w * 0.42, w * 0.7] });
      flag(w * 0.7, h, (a) => `rgba(240,237,230,${a})`, 'ALREADY HOLDING');
      sealRing(w * 0.7, h / 2, (t % 2.6) / 1.1, GREEN);
    },
    window(w, h, t) {
      const b0 = w * 0.34, b1 = w * 0.64;
      ticks(w, h, t, { band: [b0, b1] });
      sctx.fillStyle = EMBER(0.1);
      sctx.fillRect(b0, 4, b1 - b0, h - 8);
      flag(b1, h, EMBER, 'THE WINDOW');
    },
    press(w, h, t) {
      const lock = Math.min(1, Math.max(0, t - 0.9));
      /* freeze at the phase it reached, not a jump back */
      ticks(w, h, lock >= 1 ? 1.9 : t, { band: lock > 0 ? [w * 0.32, w * 0.62] : null });
      if (lock > 0) {
        flag(w * 0.62, h, (a) => `rgba(255,122,51,${a})`, 'YOUR PRESS');
        sealRing(w * 0.62, h / 2, Math.min(1, lock * 1.4), GREEN);
      }
    },
    proof(w, h, t) {
      ticks(w, h, t * 0.25, { dim: 0.5 });
      const n = 5, mid = h / 2;
      for (let i = 0; i < n; i++) {
        const x = w * (0.18 + i * 0.16);
        const lit = t > 0.5 + i * 0.45;
        sctx.strokeStyle = lit ? GREEN(0.85) : GREEN(0.25);
        sctx.lineWidth = 1.4 * dpr;
        sctx.strokeRect(x - 5 * dpr, mid - 5 * dpr, 10 * dpr, 10 * dpr);
        if (i && lit) {
          sctx.beginPath(); sctx.moveTo(x - 5 * dpr, mid);
          sctx.lineTo(x - w * 0.16 + 5 * dpr, mid); sctx.stroke();
        }
      }
      if (t > 3) sealRing(w * (0.18 + 4 * 0.16), mid, (t - 3) / 1.1, GREEN);
    },
    mic(w, h, t) {
      const off = Math.min(1, Math.max(0, (t - 1) * 1.6));
      const fx = w * 0.46;
      /* the moment the switch is thrown, the sound right of it is gone */
      ticks(w, h, t * 0.8, off > 0 ? { flatFrom: fx } : {});
      if (off > 0) {
        const mid = h / 2;
        sctx.strokeStyle = `rgba(125,119,110,.6)`;
        sctx.lineWidth = 1 * dpr;
        sctx.beginPath(); sctx.moveTo(fx, mid); sctx.lineTo(w - 6, mid); sctx.stroke();
        flag(fx, h, VIOLET, 'OFF IS OFF');
        sealRing(fx, mid, (t % 2.2) / 1.3, VIOLET);
      }
    },
    words(w, h, t) {
      ticks(w * 0.44, h, t, {});
      const mid = h / 2, x0 = w * 0.52;
      sctx.strokeStyle = 'rgba(190,184,174,.55)';
      sctx.lineWidth = 1.6 * dpr;
      for (let r = 0; r < 3; r++) {
        const y = mid - 14 * dpr + r * 14 * dpr;
        const full = w * 0.4 * (r === 2 ? 0.6 : 1);
        const p = Math.min(1, Math.max(0, t * 0.9 - r * 0.55));
        if (p <= 0) continue;
        sctx.beginPath(); sctx.moveTo(x0, y); sctx.lineTo(x0 + full * p, y); sctx.stroke();
      }
    },
    sleep(w, h, t) {
      ticks(w, h, t * 0.12, { dim: 0.35 });
      flag(w * 0.78, h, GREEN, 'STILL HELD');
      sealRing(w * 0.78, h / 2, (t % 3.2) / 1.4, GREEN);
    },
  };

  function drawStage(ts) {
    const w = stage.width, h = stage.height;
    sctx.clearRect(0, 0, w, h);
    /* the one reduced-motion frame must show every vignette settled */
    const t = reduced ? 4.2 : (ts - enterAt) / 1000;
    const vig = cur >= 0 ? VIGS[ST[cur].vig] : null;
    if (vig) vig(w, h, Math.max(0, t));
    else ticks(w, h, ts / 1000, {});
  }
  function drawRail() {
    const w = rail.width, h = rail.height, mid = h / 2;
    rctx.clearRect(0, 0, w, h);
    /* night at both ends of the day */
    rctx.fillStyle = nightGrad; rctx.fillRect(0, 0, w, h);
    rctx.fillStyle = 'rgba(66,60,51,.9)';
    rctx.fillRect(0, mid - 0.5 * dpr, w, 1 * dpr);
    for (let hh = 0; hh <= 24; hh++) {
      const x = (hh / 24) * w;
      const big = hh % 6 === 0;
      rctx.strokeStyle = `rgba(125,119,110,${big ? 0.7 : 0.35})`;
      rctx.lineWidth = 1 * dpr;
      rctx.beginPath(); rctx.moveTo(x, mid - (big ? 7 : 4) * dpr);
      rctx.lineTo(x, mid + (big ? 7 : 4) * dpr); rctx.stroke();
    }
    const px = (dayT / 24) * w;
    rctx.strokeStyle = dragging ? 'rgba(255,122,51,.95)' : 'rgba(240,237,230,.85)';
    rctx.lineWidth = 1.6 * dpr;
    rctx.beginPath(); rctx.moveTo(px, mid - 12 * dpr); rctx.lineTo(px, mid + 12 * dpr); rctx.stroke();
  }
  function paint(ts) { drawStage(ts); drawRail(); }
  function loop(ts) {
    if (!dragging && !reduced) stepAuto(ts);
    paint(ts);
    requestAnimationFrame(loop);
  }

  /* drag the day; the playhead is orange only in your hand. Drags may
     start on a dot - a click only counts if the pointer barely moved. */
  let pid = null, downX = 0, moved = false, suppressClickUntil = 0;
  wrap.addEventListener('pointerdown', e => {
    if (pid !== null) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    pid = e.pointerId; dragging = true; downX = e.clientX; moved = false;
    wrap.setPointerCapture(e.pointerId);
    if (!e.target.closest('.dev-dot')) { e.preventDefault(); scrub(e); }
  });
  function scrub(e) {
    const r = rail.getBoundingClientRect();
    dayT = Math.min(23.99, Math.max(0, ((e.clientX - r.left) / r.width) * 24));
    const n = nearest(dayT);
    byHand = true;
    if (n.d < 0.6) setStation(n.i, performance.now());
    if (reduced) paint(performance.now());
  }
  wrap.addEventListener('pointermove', e => {
    if (!dragging || e.pointerId !== pid) return;
    if (!moved && Math.abs(e.clientX - downX) > 6) moved = true;
    if (moved) scrub(e);
  });
  const endDrag = e => {
    if (!dragging || e.pointerId !== pid) return;
    dragging = false; pid = null;
    if (moved) {
      suppressClickUntil = performance.now() + 80;
      const n = nearest(dayT);
      if (n.d < 0.6) { setStation(n.i, performance.now()); mode = 'dwell'; enterAt = performance.now(); }
      else {
        travelFrom = dayT; travelT0 = performance.now();
        target = n.i; mode = 'travel'; shortWay = true;
      }
    }
    if (reduced) paint(performance.now());
  };
  wrap.addEventListener('pointerup', endDrag);
  wrap.addEventListener('pointercancel', endDrag);
  dots.forEach((d, i) => d.addEventListener('click', () => {
    if (performance.now() < suppressClickUntil) return;
    byHand = true;
    if (i === cur) { mode = 'dwell'; enterAt = performance.now(); setStation(i, performance.now()); return; }
    travelFrom = dayT; travelT0 = performance.now(); target = i;
    if (reduced) { dayT = ST[i].hour; setStation(i, performance.now()); paint(performance.now()); }
    else mode = 'travel';
  }));

  size();
  addEventListener('resize', size);
  const io = new IntersectionObserver(es => {
    if (es.some(x => x.isIntersecting)) {
      io.disconnect();
      travelT0 = performance.now();
      if (reduced) { dayT = ST[0].hour; setStation(0, performance.now()); paint(performance.now()); }
      else requestAnimationFrame(loop);
    }
  }, { threshold: 0 });
  io.observe(stage.closest('.dev') || stage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-timeline"] && !Shopify.designMode) return;
  try {
    
const story = document.getElementById('story');
const fill = document.getElementById('spine-fill');
const depthV = document.getElementById('depth-v');
const beats = [...story.querySelectorAll('.beat')];

story.classList.add('js');
const io = new IntersectionObserver((es) => {
  for (const e of es) if (e.isIntersecting) e.target.classList.add('lit');
}, { threshold: 0.35 });
beats.forEach(b => io.observe(b));

function fmtDepth(s) {
  if (s <= 0) return '0:00';
  if (s < 3600) return '−' + Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0');
  if (s < 172800) return '−' + (s / 3600).toFixed(1) + ' HRS';
  return '−' + Math.round(s / 86400) + ' DAYS';
}
/* each beat holds while it is read and the depth travels between beats;
   the tape (story-visual.js) reads this same curve so head and clock agree */
window.storyDwell = (t) => {
  const x = Math.min(1, Math.max(0, (t - 0.27) / 0.46));
  return x * x * (3 - 2 * x);
};
/* scroll scrub: interpolate the time depth between beat anchors */
function onScroll() {
  const r = story.getBoundingClientRect();
  const mid = innerHeight * 0.5;
  const total = r.height;
  const y = Math.min(Math.max(mid - r.top, 0), total);
  fill.style.height = (y / total * 100) + '%';
  let depth = 0;
  for (let i = 0; i < beats.length; i++) {
    const br = beats[i].getBoundingClientRect();
    const c = br.top + br.height / 2 - r.top;
    const d = Number(beats[i].dataset.depth || 0);
    const prevC = i === 0 ? 0 : beats[i-1].getBoundingClientRect().top + beats[i-1].offsetHeight / 2 - r.top;
    const prevD = i === 0 ? 0 : Number(beats[i-1].dataset.depth || 0);
    if (y <= c) { depth = prevD + (d - prevD) * window.storyDwell(Math.max(0, (y - prevC) / Math.max(1, c - prevC))); break; }
    depth = d;
  }
  depthV.textContent = fmtDepth(depth);
  cutUnderStage();
}
const stageEl = story.querySelector('.stage');
const beatsEl = story.querySelector('.beats');
const narrow = matchMedia('(max-width: 979px)');
function cutUnderStage() {
  if (!narrow.matches) { beatsEl.style.removeProperty('--cut'); return; }
  const cut = stageEl.getBoundingClientRect().bottom - beatsEl.getBoundingClientRect().top;
  beatsEl.style.setProperty('--cut', Math.max(0, cut).toFixed(1) + 'px');
}
addEventListener('scroll', onScroll, { passive: true });
addEventListener('resize', onScroll);
onScroll();

  } catch(e) { console.error(e); }
})();
})();
